import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RelatedItemInterface } from '../../model/related-item.interface';
import { faEdit, faInfo, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-related-item',
  templateUrl: './related-item.component.html',
  styleUrls: ['./related-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemComponent {
  icons = { faEdit, faInfo, faInfoCircle };

  @Output()
  selectRelatedObjectInfoEvent: EventEmitter<RelatedItemInterface> = new EventEmitter();

  @Output()
  selectRelatedObjectToHighlightEvent: EventEmitter<RelatedItemInterface> = new EventEmitter();

  @Output()
  selectRelatedObjectForEditGeometryEvent: EventEmitter<RelatedItemInterface> = new EventEmitter();
  
  @Output()
  deselectRelatedObjectEvent: EventEmitter<RelatedItemInterface> = new EventEmitter();

  private _relatedItem: RelatedItemInterface;

  @Input()
  get relatedItem(): RelatedItemInterface {
    return this._relatedItem;
  }
  set relatedItem(relatedItem: RelatedItemInterface) {
    this._relatedItem = (!!relatedItem && relatedItem) || null;
  }

  @Input() selectedRelatedItemBackground;

  onSelectRelatedObjectForInfo(item: RelatedItemInterface) {
    console.log("info");
    this.selectRelatedObjectInfoEvent.emit(item);
  }

  onSelectRelatedObjectToHighlight(item: RelatedItemInterface) {
    console.log("high");
    this.selectRelatedObjectToHighlightEvent.emit(item);
  }

  onSelectRelatedObjectToEdit(item: RelatedItemInterface) {
    console.log("edit");
    this.selectRelatedObjectForEditGeometryEvent.emit(item);
  }
  onDeselectRelatedObject(item: RelatedItemInterface) {
    console.log("deselect");
    this.deselectRelatedObjectEvent.emit(item);
  }
}
